import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18next
  .use(initReactI18next)
  .use(backend)
  .use(LanguageDetector)
  .init({
    supportedLngs: ["en", "ar", "id", "pt", "ru", "tr", "uk"],
    // lng commented to allow auto-detection mode
    // lng: "en",
    fallbackLng: "en",
    keySeparator: false,
    nsSeparator: false,
    namespaceSeparator: false,
    interpolation: {
      escapeValue: false
    },
    nonExplicitSupportedLngs: true,
    debug: false,
  });

export default i18next;
